var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._l((_vm.headers),function(header,index){return _c('th',{key:index},[_vm._v(" "+_vm._s(header)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }